<template>
    <div
        v-if="open"
        class="bento-overlay"
        :class="{ 'bento-overlay--elevated': elevated }"
        @click.self="$emit('close')"
    >
        <div
            class="bento-shell"
            :class="sizeClass"
            role="dialog"
            aria-modal="true"
            :aria-labelledby="titleId"
            @click.stop
        >
            <header v-if="showHeader" class="bento-head">
                <div class="bento-head__text">
                    <slot name="header">
                        <div v-if="eyebrow" class="bento-eyebrow" :class="{ 'bento-eyebrow--accent': accentEyebrow }">
                            {{ eyebrow }}
                        </div>
                        <component :is="titleTag" :id="titleId" class="bento-title">
                            {{ title }}
                        </component>
                        <p v-if="subtitle" class="bento-subtitle">{{ subtitle }}</p>
                    </slot>
                </div>
                <div class="bento-head__toolbar">
                    <slot name="header-actions" />
                    <button type="button" class="bento-close" aria-label="Закрыть" @click="$emit('close')">
                        <ChatIcon name="x" :size="16" color="currentColor" />
                    </button>
                </div>
            </header>

            <div class="bento-shell__body" :class="{ 'bento-shell__body--flush': bodyFlush }">
                <slot />
            </div>

            <footer v-if="$slots.footer" class="bento-shell__footer">
                <slot name="footer" />
            </footer>
        </div>
    </div>
</template>

<script setup>
import { computed, onBeforeUnmount, watch } from 'vue'
import '@/components/chat/bento/bento-shared.css'
import ChatIcon from '@/components/chat/icons/ChatIcon.vue'

const props = defineProps({
    open: { type: Boolean, default: false },
    size: {
        type: String,
        default: 'medium',
        validator: v => ['narrow', 'medium', 'large', 'wide', 'chart'].includes(v),
    },
    eyebrow: { type: String, default: '' },
    accentEyebrow: { type: Boolean, default: false },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    titleTag: { type: String, default: 'h2' },
    bodyFlush: { type: Boolean, default: false },
    showHeader: { type: Boolean, default: true },
    elevated: { type: Boolean, default: false },
})

defineEmits(['close'])

watch(
    () => props.open,
    isOpen => {
        if (typeof document === 'undefined') return
        document.body.style.overflow = isOpen ? 'hidden' : ''
    },
    { immediate: true },
)

onBeforeUnmount(() => {
    if (typeof document !== 'undefined') {
        document.body.style.overflow = ''
    }
})

const titleId = computed(() => (props.title ? `am-modal-title-${Math.random().toString(36).slice(2, 9)}` : undefined))

const sizeClass = computed(() => {
    const map = {
        narrow: 'bento-shell--narrow',
        medium: 'bento-shell--medium',
        large: 'bento-shell--large',
        wide: 'bento-shell--wide',
        chart: 'bento-shell--chart',
    }
    return map[props.size] || map.medium
})
</script>
